import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { onDeleteAddUser } from '../handler/UserManagementHandler';

function ConfirmDeleteNewOrgUserDialog({ openConfirmModal, argsAll }) {

    const handleCloseConfirmModal = () => {
        argsAll.setOpenConfirmModal({ isOpen: false, userId: null });
    };

    const handleDeleteUser = () => {
        onDeleteAddUser(openConfirmModal.userId, argsAll);
    };

    return (
        <Dialog
            open={openConfirmModal.isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <div className="dialog-content">
                    {I18n.get('USER12MSG005')}
                </div>
            </DialogContent>
            <DialogActions className="dialog-action-delete">
                <Button
                    className="dialog-button-delete"
                    variant="contained"
                    onClick={() => handleDeleteUser()}
                >
                    {I18n.get('COMBTN002')}
                </Button>
                <Button
                    className="dialog-action-cancel"
                    variant="contained"
                    onClick={() => handleCloseConfirmModal()}
                >
                    {I18n.get('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDeleteNewOrgUserDialog;
